import { useTenant } from '@/lib/hooks/useTenant';
import { Button } from 'components/Button/Button';
import { useTravellerCountQuery } from 'lib/react-query/Queries/useTravellerCountQuery';
import { MouseEvent } from 'react';
import { PaymentStageSessionTimer } from 'components/SessionTimer/PaymentStageSessionTimer';
type Props = {
  submitHandler: (e: MouseEvent<HTMLElement>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  submitButtonText: string;
  showLimitedSpots?: boolean;
  showTimer?: boolean;
  hideButton?: boolean;
  className?: string;
};

const ContinueCta = ({
  submitHandler,
  isDisabled,
  isLoading,
  submitButtonText,
  showLimitedSpots = true,
  showTimer = false,
  hideButton = false,
  className = '',
}: Props) => {
  const {
    isLoading: travellersCountLoading,
    data: travellerCount,
    shouldShow,
  } = useTravellerCountQuery();
  const { isDA } = useTenant();

  const shouldShowLimitedSpots =
    !travellersCountLoading && travellerCount?.result?.count && shouldShow;
  // DA two-line banner: tighten the bar so line 2 fits next to Continue at 360px
  const isDADense = isDA && showLimitedSpots && !!shouldShowLimitedSpots;

  const limitedSpots = (
    <div className={`flex items-center ${isDA ? 'gap-1.5' : 'gap-2.5'}`}>
      <p className={isDA ? 'text-base' : 'text-xl'}>🔥</p>
      {isDA ? (
        <p className="text-xs font-normal text-dark-800 !leading-4">
          <span className="font-bold text-sm leading-5">
            Don&apos;t miss this price!
          </span>{' '}
          <br />
          <span className="text-purple-900">
            {travellerCount?.result?.count}
          </span>{' '}
          recently booked with DealsAway.
        </p>
      ) : (
        <p className="text-sm font-medium text-dark-800 !leading-5">
          Limited spots.{' '}
          <span className="text-purple-900 font-bold">
            {travellerCount?.result?.count}
          </span>{' '}
          trips booked in{' '}
          <span className="whitespace-nowrap">last 7 days.</span>
        </p>
      )}
    </div>
  );

  return (
    <div id="bottom-action-bar">
      <div
        className={`w-full flex ${
          isDADense ? 'gap-3 min-[375px]:gap-4' : 'gap-2.5'
        } items-center justify-between ${
          isDADense ? 'px-4' : 'px-5'
        } h-[5.625rem] border-t border-light-900 ${className}`}
      >
        {showLimitedSpots && shouldShowLimitedSpots ? limitedSpots : null}

        {showTimer && <PaymentStageSessionTimer />}

        {!showTimer && !shouldShowLimitedSpots && <div></div>}

        <Button
          text={submitButtonText}
          clickHandler={submitHandler}
          size="medium"
          type="primary"
          isDisabled={isDisabled}
          isLoading={isLoading}
          className={`${
            isDADense
              ? 'flex-1 min-w-[6.25rem] max-w-[8.75rem] !px-3 min-[375px]:!px-4'
              : 'min-w-[8.75rem]'
          } h-[3.125rem] transition-opacity duration-300 ${
            hideButton ? 'opacity-0 pointer-events-none' : ''
          }`}
        />
      </div>
      {showTimer && (
        <div
          className={
            'block md:hidden w-full h-2.5 absolute bottom-0 timer-repeating-gradient-red'
          }
        ></div>
      )}
    </div>
  );
};

export { ContinueCta };
